import _extends from "@babel/runtime-corejs3/helpers/extends";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";

/* eslint-disable react/jsx-no-bind */
import React from 'react';
import types from 'prop-types';
import momentTypes from 'react-moment-proptypes';
import { nonNegativeInteger } from 'airbnb-prop-types';
import moment from 'moment';
import _ from 'lodash';
import { compose, branch, toClass, withHandlers, lifecycle, onlyUpdateForKeys } from 'recompose';
import { styled } from '@rexlabs/styling';
import styles from '../styles/calendar-day';
import { BLOCKED_MODIFIER, DAY_SIZE } from '../constants';
var assign = _Object$assign;

var CalendarDay = function CalendarDay(_ref) {
  var _context, _context2;

  var day = _ref.day,
      daySize = _ref.daySize,
      isOutsideDay = _ref.isOutsideDay,
      modifiers = _ref.modifiers,
      renderDay = _ref.renderDay,
      tabIndex = _ref.tabIndex,
      dateIsUnavailableLabel = _ref.dateIsUnavailableLabel,
      _onMouseEnter = _ref.onMouseEnter,
      _onMouseLeave = _ref.onMouseLeave,
      _onClick = _ref.onClick,
      setRef = _ref.setRef,
      Container = _ref.Container,
      Button = _ref.Button,
      styles = _ref.styles;
  if (!day) return /*#__PURE__*/React.createElement(Container, null);
  var ariaLabel = _includesInstanceProperty(modifiers).call(modifiers, BLOCKED_MODIFIER) ? dateIsUnavailableLabel : _concatInstanceProperty(_context = "".concat(day.format('dddd'), ", ")).call(_context, day.format('LL'));
  return /*#__PURE__*/React.createElement(Container, styles.with.apply(styles, _concatInstanceProperty(_context2 = ['container']).call(_context2, _toConsumableArray(modifiers)))({
    width: daySize,
    height: daySize - 1
  }), /*#__PURE__*/React.createElement(Button, _extends({}, styles({
    day: true,
    isOutsideDay: isOutsideDay
  }), {
    type: "button",
    ref: setRef,
    "aria-label": ariaLabel,
    onMouseEnter: function onMouseEnter(e) {
      _onMouseEnter(day, e);
    },
    onMouseLeave: function onMouseLeave(e) {
      _onMouseLeave(day, e);
    },
    onMouseUp: function onMouseUp(e) {
      e.currentTarget.blur();
    },
    onClick: function onClick(e) {
      _onClick(day, e);
    },
    tabIndex: tabIndex
  }), renderDay(day)));
};

var meta = {
  displayName: 'CalendarDay',
  propTypes: {
    day: momentTypes.momentObj,
    daySize: nonNegativeInteger,
    isOutsideDay: types.bool,
    modifiers: types.array,
    isFocused: types.bool,
    tabIndex: types.oneOf([0, -1]),
    onClick: types.func,
    onMouseEnter: types.func,
    onMouseLeave: types.func,
    renderDay: types.func,
    dateIsUnavailableLabel: types.string,
    Container: types.oneOfType([types.string, types.func]),
    Button: types.oneOfType([types.string, types.func])
  },
  defaultProps: {
    day: moment(),
    daySize: DAY_SIZE,
    isOutsideDay: false,
    modifiers: [],
    isFocused: false,
    tabIndex: -1,
    onClick: function onClick() {},
    onMouseEnter: function onMouseEnter() {},
    onMouseLeave: function onMouseLeave() {},
    renderDay: function renderDay(day) {
      return day.format('D');
    },
    dateIsUnavailableLabel: 'Not available.',
    Container: 'td',
    Button: 'button'
  }
};
var withRef = withHandlers(function () {
  var node;
  return {
    setRef: function setRef(_ref2) {
      var _ref2$setRef = _ref2.setRef,
          _setRef = _ref2$setRef === void 0 ? _.noop : _ref2$setRef;

      return function (ref) {
        node = node || ref;

        _setRef(ref);
      };
    },
    getRef: function getRef() {
      return function () {
        return node;
      };
    }
  };
});
var withLiveFocus = compose(withRef, lifecycle({
  componentDidUpdate: function componentDidUpdate(prevProps) {
    var _this$props = this.props,
        getRef = _this$props.getRef,
        isFocused = _this$props.isFocused,
        tabIndex = _this$props.tabIndex;

    if (tabIndex !== 0 || !isFocused || tabIndex === prevProps.tabIndex) {
      return;
    }

    getRef().focus();
  }
}));
export default assign(compose(onlyUpdateForKeys(['isFocused', 'tabIndex', 'modifiers']), withLiveFocus, branch(function (_ref3) {
  var setRef = _ref3.setRef;
  return !!setRef;
}, toClass), styled(styles))(CalendarDay), meta);